import About from './About'
import Home from './Home'
import ChangeLog from './ChangeLog'
import NewGameRedirect from './NewGameRedirect'
import OnlineRoom from './OnlineRoom'

export default { About, Home, ChangeLog, NewGameRedirect, OnlineRoom }
